module.exports = __webpack_public_path__ + "img/php.1fa57934.png";